module.exports = __webpack_public_path__ + "static/media/adressChange.c9fc7b21.svg";